function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var InvitationLinkTemplate = require('./saito-link.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var InvitationLink = /*#__PURE__*/function () {
  function InvitationLink(app, mod) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, InvitationLink);
    this.app = app;
    this.mod = mod;
    this.data = data;
    this.overlay = new SaitoOverlay(app, mod);
    this.invite_link = '';
    this.shortlink_promise = null;
    this.share_to_chat = true;
    this.share_to_redsquare = true;
    this.share_to_qr = true;
  }
  return _createClass(InvitationLink, [{
    key: "render",
    value: function render() {
      var display = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.buildLink();
      this.prepareShortLink();
      if (display) {
        this.overlay.show(InvitationLinkTemplate(this.app, this));
        this.attachEvents();
      } else {
        this.copyInviteLink();
      }
    }
  }, {
    key: "prepareShortLink",
    value: function prepareShortLink() {
      var _this$mod,
        _this = this;
      if (!((_this$mod = this.mod) !== null && _this$mod !== void 0 && _this$mod.shortlinks_enabled) || typeof this.mod.createShortLink !== 'function') {
        this.shortlink_promise = null;
        return;
      }
      var longLink = this.invite_link;
      this.shortlink_promise = this.mod.createShortLink(longLink).then(function (link) {
        _this.invite_link = link || longLink;
        return _this.invite_link;
      })["catch"](function (err) {
        console.error('Invite shortlink creation failed:', err);
        _this.invite_link = longLink;
        return longLink;
      });
    }
  }, {
    key: "returnInviteLink",
    value: function () {
      var _returnInviteLink = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.shortlink_promise) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return this.shortlink_promise;
            case 1:
              return _context.a(2, this.invite_link);
          }
        }, _callee, this);
      }));
      function returnInviteLink() {
        return _returnInviteLink.apply(this, arguments);
      }
      return returnInviteLink;
    }()
  }, {
    key: "copyInviteLink",
    value: function () {
      var _copyInviteLink = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var link, game;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.returnInviteLink();
            case 1:
              link = _context2.v;
              _context2.n = 2;
              return navigator.clipboard.writeText(link);
            case 2:
              game = this.data.name || this.data.game;
              siteMessage("".concat(game, " invite link copied to clipboard"), 2500);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function copyInviteLink() {
        return _copyInviteLink.apply(this, arguments);
      }
      return copyInviteLink;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      try {
        document.querySelector('#copy-invite-link').addEventListener('click', /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  _context3.n = 1;
                  return _this2.copyInviteLink();
                case 1:
                  _this2.overlay.remove();
                case 2:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } catch (err) {
        console.error(err);
      }
      if (document.getElementById('chat-invite-link')) {
        document.getElementById('chat-invite-link').onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
            var link;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  _context4.n = 1;
                  return _this2.returnInviteLink();
                case 1:
                  link = _context4.v;
                  _this2.app.connection.emit('chat-message-user', 'community', link);
                  _this2.app.connection.emit('open-chat-with');
                  _this2.overlay.remove();
                case 2:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('tweet-invite-link')) {
        document.getElementById('tweet-invite-link').onclick = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
            var link;
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.n) {
                case 0:
                  _context5.n = 1;
                  return _this2.returnInviteLink();
                case 1:
                  link = _context5.v;
                  _context5.n = 2;
                  return navigator.clipboard.writeText(link);
                case 2:
                  _this2.overlay.remove();
                  _this2.app.connection.emit('redsquare-new-post', link);
                case 3:
                  return _context5.a(2);
              }
            }, _callee5);
          }));
          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('qr-invite-link')) {
        document.getElementById('qr-invite-link').onclick = /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(e) {
            var link, qr_overlay, html, data;
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.n) {
                case 0:
                  _context6.n = 1;
                  return _this2.returnInviteLink();
                case 1:
                  link = _context6.v;
                  _this2.overlay.remove();
                  qr_overlay = new SaitoOverlay(_this2.app, _this2.mod);
                  html = "<div class=\"qr-share-overlay\">\n\t\t\t\t<div class=\"qr-share-header\">Scan for ".concat(_this2.data.name || _this2.data.game, "</div>\n\t\t\t\t<div id=\"qr-share-link\"></div></div>");
                  qr_overlay.show(html);
                  data = {
                    text: link
                  };
                  _this2.app.browser.generateQRCode(data, 'qr-share-link');
                case 2:
                  return _context6.a(2);
              }
            }, _callee6);
          }));
          return function (_x4) {
            return _ref4.apply(this, arguments);
          };
        }();
      }
    }
  }, {
    key: "buildLink",
    value: function buildLink() {
      var _this$data;
      this.invite_link = window.location.origin;
      var path = ((_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.path) || window.location.pathname;
      this.invite_link += path;

      //Make sure we have the final /
      if (this.invite_link.slice(-1) != '/') {
        this.invite_link += '/';
      }
      for (var key in this.data) {
        if (key !== 'path' && key !== 'name') {
          var val = this.data[key];
          this.invite_link += '&' + key + '=' + encodeURIComponent(val != null ? val : '');
        }
      }
      this.invite_link = this.invite_link.replace('/&', '/?');
      console.log(this.invite_link);
    }
  }]);
}();
module.exports = InvitationLink;